import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const categories = ['Technology', 'Marketing', 'Design', 'HR', 'Finance', 'Education', 'Healthcare', 'Sales'];
const frequencies = [
  { value: 'instant', label: 'Instant',   icon: 'fa-bolt',        desc: 'Get notified immediately', color: '#ef4444', bg: '#fff0f0' },
  { value: 'daily',   label: 'Daily',     icon: 'fa-calendar-day', desc: 'Once a day digest',        color: '#0066FF', bg: '#e8f0ff' },
  { value: 'weekly',  label: 'Weekly',    icon: 'fa-calendar-week',desc: 'Weekly job roundup',       color: '#00C896', bg: '#e6fff6' },
];

const benefits = [
  { icon: 'fa-bolt',        color: '#0066FF', bg: '#e8f0ff', title: 'Real-Time Alerts',      desc: 'Be the first to know when a matching job is posted.' },
  { icon: 'fa-filter',      color: '#00C896', bg: '#e6fff6', title: 'Smart Filtering',        desc: 'Only get alerts for jobs that match your exact criteria.' },
  { icon: 'fa-bell-slash',  color: '#f59e0b', bg: '#fff8e6', title: 'Easy Unsubscribe',       desc: 'One click to pause or stop alerts anytime.' },
  { icon: 'fa-mobile-alt',  color: '#8b5cf6', bg: '#f3eeff', title: 'Multi-Channel',          desc: 'Receive alerts via email or directly on the platform.' },
];

export default function JobAlerts() {
  const [form, setForm]       = useState({ email: '', keyword: '', location: '', category: '', frequency: 'daily' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.email) return setError('Email is required');
    if (!form.keyword && !form.category) return setError('Enter a keyword or select a category');
    setError('');
    setSubmitted(true);
  };

  return (
    <>
      <PageHeader title="Job Alerts" breadcrumb="Job Alerts" />

      {/* Hero */}
      <section style={{ background: 'linear-gradient(135deg, #0066FF 0%, #0044cc 100%)', padding: '60px 0' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: 28, color: '#fff' }}>
            <i className="fa fa-bell"></i>
          </div>
          <h2 style={{ color: '#fff', fontWeight: 800, fontSize: 32, marginBottom: 12 }}>Never Miss Your Dream Job</h2>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 16, maxWidth: 520, margin: '0 auto' }}>
            Set up personalised job alerts and get notified the moment a matching opportunity is posted.
          </p>
        </div>
      </section>

      {/* Alert Form */}
      <section className="section-pad">
        <div className="container">
          <div style={{ maxWidth: 680, margin: '0 auto' }}>
            <div style={{ background: '#fff', borderRadius: 20, padding: 36, border: '1.5px solid #eef0f8', boxShadow: '0 8px 40px rgba(0,0,0,0.07)' }}>
              <h4 style={{ fontWeight: 700, color: '#0A1628', marginBottom: 6 }}>Create Your Job Alert</h4>
              <p style={{ color: '#888', fontSize: 14, marginBottom: 28 }}>Fill in your preferences and we'll send matching jobs straight to your inbox.</p>

              {submitted ? (
                <div style={{ textAlign: 'center', padding: '32px 0' }}>
                  <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#e6fff6', color: '#00C896', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, margin: '0 auto 16px' }}>
                    <i className="fa fa-check"></i>
                  </div>
                  <h5 style={{ fontWeight: 700, color: '#0A1628', marginBottom: 8 }}>Alert Created Successfully!</h5>
                  <p style={{ color: '#888', fontSize: 14, marginBottom: 24 }}>We'll notify you at <strong>{form.email}</strong> when matching jobs are posted.</p>
                  <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                    <button onClick={() => { setSubmitted(false); setForm({ email: '', keyword: '', location: '', category: '', frequency: 'daily' }); }} style={{ padding: '10px 24px', borderRadius: 10, border: '1.5px solid #eef0f8', background: '#fafbff', fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>
                      Create Another
                    </button>
                    <Link to="/job-list" className="jd-apply-btn" style={{ textDecoration: 'none' }}>Browse Jobs Now</Link>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  {error && <div className="auth-alert error mb-3"><i className="fa fa-exclamation-circle me-2"></i>{error}</div>}

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 600, color: '#444', display: 'block', marginBottom: 6 }}>Email Address <span style={{ color: '#ef4444' }}>*</span></label>
                      <div className="input-wrap">
                        <i className="fa fa-envelope input-icon"></i>
                        <input type="email" placeholder="you@example.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                      </div>
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 600, color: '#444', display: 'block', marginBottom: 6 }}>Job Title / Keyword</label>
                      <div className="input-wrap">
                        <i className="fa fa-search input-icon"></i>
                        <input type="text" placeholder="e.g. React Developer" value={form.keyword} onChange={e => setForm({ ...form, keyword: e.target.value })} />
                      </div>
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 600, color: '#444', display: 'block', marginBottom: 6 }}>Location</label>
                      <div className="input-wrap">
                        <i className="fa fa-map-marker-alt input-icon"></i>
                        <input type="text" placeholder="e.g. Mumbai, Remote" value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} />
                      </div>
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 600, color: '#444', display: 'block', marginBottom: 6 }}>Category</label>
                      <div className="input-wrap">
                        <i className="fa fa-th-large input-icon"></i>
                        <select value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}>
                          <option value="">All Categories</option>
                          {categories.map(c => <option key={c}>{c}</option>)}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div style={{ marginBottom: 24 }}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: '#444', display: 'block', marginBottom: 10 }}>Alert Frequency</label>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12 }}>
                      {frequencies.map(f => (
                        <div key={f.value} onClick={() => setForm({ ...form, frequency: f.value })}
                          style={{ padding: '14px 12px', borderRadius: 12, border: `2px solid ${form.frequency === f.value ? f.color : '#eef0f8'}`, background: form.frequency === f.value ? f.bg : '#fafbff', cursor: 'pointer', textAlign: 'center', transition: 'all .2s' }}>
                          <i className={`fa ${f.icon}`} style={{ fontSize: 20, color: f.color, marginBottom: 6, display: 'block' }}></i>
                          <div style={{ fontWeight: 700, fontSize: 13, color: '#0A1628' }}>{f.label}</div>
                          <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>{f.desc}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <button type="submit" className="btn-auth-submit">
                    <i className="fa fa-bell me-2"></i> Create Job Alert
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="section-pad" style={{ background: '#f8faff' }}>
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Why Set Alerts</span>
            <h2 className="section-title">Stay Ahead of the Competition</h2>
            <p className="section-sub">Job alerts give you a head start — apply before others even know the job exists</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 24 }} className="cat-why-grid">
            {benefits.map((b, i) => (
              <div key={i} className="cat-why-card" style={{ background: '#fff', borderRadius: 20, padding: '28px 24px', border: '1.5px solid #eef0f8', textAlign: 'center', transition: 'all .25s' }}>
                <div style={{ width: 60, height: 60, borderRadius: 16, background: b.bg, color: b.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, margin: '0 auto 16px' }}>
                  <i className={`fa ${b.icon}`}></i>
                </div>
                <h6 style={{ fontSize: 15, fontWeight: 700, color: '#0A1628', marginBottom: 8 }}>{b.title}</h6>
                <p style={{ fontSize: 13, color: '#888', lineHeight: 1.7, margin: 0 }}>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-left">
              <h2>Ready to Find Your Dream Job?</h2>
              <p>Browse thousands of live job listings right now.</p>
            </div>
            <div className="cta-right">
              <Link to="/job-list" className="cta-btn-white">Browse Jobs</Link>
              <Link to="/login" className="cta-btn-outline">Create Profile</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
